<div class="main-home">
  <section class="home-offers">
    <div class="top-home">
      <div class="row container align-items-center">
        <div class="col-12">
          <h1>Somos el marketplace <br class="break-mobile"><span>conectado a tu información<br class="break-mobile"> en </span><br class="break-desktop"><span>Midatacrédito</span> con oportunidades financieras a <span class="hl-nowrap">tu medida.</span></h1>
        </div>
      </div>
    </div>
    <div class="categories">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="box-categories">
              <div class="title">
                <h2>Encuentra el producto perfecto para ti, a tu medida según tu perfil de crédito:</h2>
              </div>
              <div class="content-categories">
                @for (cat of listCategories; track cat) {
                <div class="card-category" (click)="irCategorias(cat.url,cat.name)">
                  <img class="img-cover" [src]="cat.backImg" [alt]="cat.name" [title]="cat.name" />
                  <p class="title-category" [innerHTML]="cat.title"></p>
                  <div class="desc-category">
                    <i class="fa fa-sort-up" aria-hidden="true"></i>
                    <div class="section-comment d-none d-md-block">
                      <img [src]="cat.icon" [alt]="cat.name" [title]="cat.name" />
                    </div>
                    <div class="section-comment">
                      <p [innerHTML]="cat.comment"></p>
                    </div>
                  </div>
                </div>
                }
              </div>
              <div class="cta-ver-ofertas">
                <button (click)="irCategorias()">Ver Ofertas</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-micro-loader></app-micro-loader>
    @if (!noOffers) {
    <div class="offers">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="box-offers-top">
              <div class="title">
                <div class="hash">
                  <p>#NuestrosALIADOS</p>
                  <i class="fa fa-sort-down" aria-hidden="true"></i>
                </div>
                <h2>OFERTAS DESTACADAS:</h2>
                <p>Con las ofertas destacadas para este mes.</p>
              </div>
              <div class="content-offers" [ngClass]="{'justify-content-around':topOffers.length < 3}">
                @for (oferta of topOffers; track oferta; let i = $index) {
                <div class="content-card">
                  <!-- marketplace-card: reutiliza los ajustes de card-offer (:host-context) para que
                       la card del home se vea igual que la del marketplace. -->
                  <app-card class="marketplace-card" [data]="oferta" [type]="'normal'"></app-card>
                </div>
                }
              </div>
              <div id="carousel-m" class="carousel d-block d-md-none" data-ride="carousel" data-interval="false">
                <div class="carousel-inner">
                  @for (oferta of topOffers; track oferta; let i = $index) {
                  <div class="content-card carousel-item" [ngClass]="{'active': i==0}">
                    <!-- Carrusel móvil: misma card y mismos ajustes (marketplace-card) que el marketplace y que
                         el listado desktop de arriba, en vez de la variante 'nueva'. -->
                    <app-card class="marketplace-card" [data]="oferta" [type]="'normal'"></app-card>
                  </div>
                  }
                </div>
                @if (topOffers.length > 1) {
                <ul class="carousel-indicators circles">
                  @for (debt of topOffers; track debt; let i = $index) {
                  <li data-target="#carousel-m" class="btnCircle" [ngClass]="{'active': i==0}"
                    (click)="addClass($event,'active')" [attr.data-slide-to]="i">
                    <i class="fa fa-circle"></i>
                  </li>
                  }
                </ul>
                }
                @if (topOffers.length > 1) {
                <a class="carousel-control-prev spaceBtn" href="#carousel-m" data-slide="prev">
                  <i class="fa fa-angle-left"></i>
                  <span class="sr-only">Previous</span>
                </a>
                }
                @if (topOffers.length > 1) {
                <a class="carousel-control-next spaceBtn" href="#carousel-m" data-slide="next">
                  <i class="fa fa-angle-right"></i>
                  <span class="sr-only">Next</span>
                </a>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
    <div class="how-works">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="title">
              <div class="hash">
                <p>#ATuMedida</p>
                <i class="fa fa-sort-down" aria-hidden="true"></i>
              </div>
              <h2>¿CÓMO FUNCIONA BUSCACRÉDITO?</h2>
            </div>
            <div class="steps">
              <div class="step">
                <p>1. INICIA SESIÓN O REGÍSTRATE:</p>
                <p>Para ver únicamente las ofertas que se ajustan a tu situación financiera.</p>
              </div>
              <div class="step">
                <p>2. EXPLORA LAS OFERTAS:</p>
                <p>Navega por las diferentes categorías y productos para encontrar la opción perfecta.
                </p>
              </div>
              <div class="step">
                <p>3. APLICA A LA OFERTA IDEAL:</p>
                <p>Finaliza el proceso con la entidad y disfruta de tu producto financiero.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sponsors">
      <div class="container">
        <div class="row">
          <div class="col-12 d-flex d-md-none">
            @if (isMobile) {
            <div id='div-gpt-ad-1683582277702-0' class="commercial-banner">
            </div>
            }
          </div>
          <div class="col-12">
            <div class="title">
              <div class="hash">
                <p>#NuestrosALIADOS</p>
                <i class="fa fa-sort-down" aria-hidden="true"></i>
              </div>
              <h2>Conoce toda la red de <b>ALIADOS</b> que forman parte de nuestro ecosistema:</h2>
            </div>
          </div>
        </div>
      </div>
      <app-sponsors></app-sponsors>
    </div>
    <div class="testimonials">
      <div class="container">
        <div class="row">
          <div class="col-12 d-none d-md-flex">
            @if (!isMobile) {
            <div id='div-gpt-ad-1683582277702-0' class="commercial-banner">
            </div>
            }
          </div>
          <div class="col-12">
            <app-testimonials class="d-none d-md-block" [testimonials]="testimonials"></app-testimonials>
          </div>
        </div>
      </div>
      <app-testimonials class="d-block d-md-none" [testimonials]="testimonials"></app-testimonials>
    </div>
  </section>
</div>